import React, {memo} from "react";
import {color} from "constants/color.consts";

export const ButtonRed = memo(({name, onClick, type, disabled}) => {
  const styles = {
    background: disabled ? color.lightGray : color.red,
    color: disabled ? color.midGray : color.white,
  };

  return (
    <button
      style={styles}
      type={type}
      className="button-red"
      onClick={onClick}
      disabled={disabled}
    >
      {name}
    </button>
  );
});
